import { FC } from 'react';

import { useSelector } from 'react-redux';

import NeoLeoThinking from '../../assets/img/NeoLeoThinking.mp4';

import { RootState } from '../../types';

interface NeoLeoIntroProps {}

const NeoLeoIntro: FC<NeoLeoIntroProps> = () => {
  const { authUserDetail } = useSelector((state: RootState) => state.auth);

  return (
    <div className='h-full flex flex-col flex-grow overflow-auto scrollbar-hide pb-4'>
      <div className='px-6 mb-10'>
        <video
          src={NeoLeoThinking}
          autoPlay
          loop
          muted
          className='w-24 h-auto mt-8 mb-6 rounded-full'
        />
        <p className='font-poppins text-white font-normal text-3xl mb-1'>
          Hi {authUserDetail?.firstName}
        </p>
        <p
          className='font-poppins text-[#828CB3] font-normal text-3xl'
          data-testid='how-can-i-help-you-paragraph'
        >
          How can I help you today?
        </p>
      </div>
    </div>
  );
};

export default NeoLeoIntro;
